export default {
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    edit: '편집',
    delete: '삭제',
    loading: '로딩 중...',
    loadMore: '더 보기',
    noMore: '더 이상 없음',
    retry: '다시 시도',
    back: '뒤로',
    next: '다음',
    prev: '이전',
    submit: '제출',
    reset: '초기화',
    search: '검색',
    filter: '필터',
    sort: '정렬',
    refresh: '새로고침',
    complete: '완료',
    skip: '건너뛰기',
    download: '다운로드',
  },
  nav: {
    discover: '홈',
    message: '메시지',
    store: '스토어',
    mine: '마이',
    recommend: '추천',
  },
  scene: {
    changeScene: '장면 변경',
    seeAll: '전체 보기',
    putAway: '접기',
    selectScene: '이 장면 선택',
    selected: '선택됨',
    sceneIndex: '장면 {num}',
  },
  home: {
    title: '롤플레이 세계',
    subtitle: '당신의 이야기를 시작하세요',
    startGame: '게임 시작',
    continueGame: '계속하기',
    newGame: '새 게임',
    gameLibrary: '라이브러리',
    featured: '추천',
    popular: '인기',
    recent: '최근',
    searchHistory: '검색',
    search: '역할 검색...',
    noData: '데이터 없음',
    noMoreData: '더 이상 데이터 없음',
    noNetwork: '네트워크 없음',
    pleaseSelectFilter: '필터 조건을 선택하세요',
  },
  user: {
    login: '로그인',
    register: '회원가입',
    logout: '로그아웃',
    profile: '프로필',
    avatar: '아바타',
    nickname: '닉네임',
    email: '이메일',
    phone: '전화번호',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    oldPassword: '이전 비밀번호',
    newPassword: '새 비밀번호',
    forgotPassword: '비밀번호 찾기',
    changePassword: '비밀번호 변경',
    bindPhone: '전화번호 연결',
    verifyCode: '인증 코드',
    sendCode: '코드 전송',
    level: '레벨',
    experience: '경험치',
    achievement: '업적',
    history: '기록'
  },
  game: {
    character: '캐릭터',
    story: '스토리',
    chapter: '챕터',
    scene: '장면',
    dialogue: '대화',
    choice: '선택',
    inventory: '인벤토리',
    achievement: '업적',
    save: '저장',
    load: '불러오기',
    restart: '재시작',
    pause: '일시정지',
    resume: '재개',
    auto: '자동',
    speed: '속도',
    volume: '볼륨',
    settings: '게임 설정'
  },
  message: {
    success: '성공',
    error: '오류',
    warning: '경고',
    info: '정보',
    networkError: '네트워크 오류',
    serverError: '서버 오류',
    loginSuccess: '회원가입 성공',
    loginFailed: '회원가입 실패',
    logoutSuccess: '로그아웃 성공',
    saveSuccess: '저장 성공',
    saveFailed: '저장 실패',
    deleteConfirm: '삭제 확인?',
    operationConfirm: '작업 확인?',
    noNewsYet: '아직 메시지 없음',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    deleteMessage: '이 메시지를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다!',
    delete: '삭제',
    deleting: '삭제 중...',
    noMoreData: '더 이상 메시지 없음',
    downloading: '다운로드 중...',
    downloadSuccess: '다운로드 성공',
    downloadFailed: '다운로드 실패',
    copySuccess: '복사 성공',
    copyFailed: '복사 실패',
    reportSuccess: '신고 성공',
    reportFailed: '신고 실패',
    translating: '번역 중...',
    translateSuccess: '번역 성공',
    translateFailed: '번역 실패',
    noMoreMessages: '더 이상 메시지 없음',
    loading_more: '로딩 중...',
    pleaseWaitForReply: '삭제하기 전에 답변이 완료될 때까지 기다려주세요',
    pleaseWaitForReplyCurrent: '현재 메시지의 답변이 완료될 때까지 기다려주세요',
    chat_placeholder: '하고 싶은 말을 입력하세요...',
    setAsBackdropConfirm: '배경으로 설정',
    setAsBackdropMessage: '이 이미지를 배경으로 설정하시겠습니까?',
    sendFailed: '전송 실패',
    sending: '전송 중...',
    introNoYet: '아직 소개 없음. 채팅해서 직접 확인하세요.',
    introLabel: '소개:',
    thinking: '생각 중',
    think: '생각',
    translate: '번역',
    pleaseUnlock: '잠금을 해제해 주세요',
    tryAgain: '다시 시도',
    create: '생성',
    free: '무료',
    video: '비디오',
    chatMateTyping: '채팅 상대가 입력 중입니다...',
    aiAssistant: 'AI 어시스턴트',
    imageFailed: '이미지 생성 실패',
    generatingImage: '이미지 생성을 기다려주세요',
    switchSceneSuccess: '장면 전환 성공',
    switchSceneFailed: '장면 전환 실패',
    switchingScene: '장면 전환 중...',
    perMessage: '/메시지',
    allChat: '모든 채팅',
    like: '좋아요',
    saving: '저장 중...',
    saved: '저장됨',
    placeholderBlur: '하고 싶은 말을 입력하세요...',
    placeholderFocus: '채팅을 생동감 있게 하려면 ** 내에 액션이나 장면 세부 정보를 입력하세요.',
    successfulSwitch: '전환 성공',
    setting: '설정 중...',
    uploading: '업로드 중...',
    purchaseSuccessful: '구매 성공',
    processing: '처리 중...',
    gettingReward: '보상 받는 중...',
    checkIn: '체크인 중...',
    deleteHistory: '기록 삭제',
    openingRemarksTitle: '인사하세요～',
  },
  error: {
    notFound: '페이지를 찾을 수 없음',
    networkError: '네트워크 오류',
    serverError: '서버 오류',
    permissionDenied: '권한 거부',
    goHome: '홈으로 이동',
    tryAgain: '다시 시도',
    uploadFailed: '업로드 실패',
    saveFailed: '저장 실패',
    translationFailed: '번역 실패',
    generateImageFailed: '이미지 생성 실패',
  },
  notFound: {
    title: '페이지를 찾을 수 없음',
    description: '찾고 있는 페이지가 존재하지 않거나 이동되었습니다.',
    goHome: '홈으로 이동',
    goBack: '뒤로'
  },
  settings: {
    language: '언어',
    theme: '테마',
    notification: '알림',
    privacy: '개인정보',
    security: '보안',
    about: '정보',
    version: '버전',
    checkUpdate: '업데이트 확인',
    clearCache: '캐시 지우기',
    systemNotification: '시스템 알림',
    termsOfService: '서비스 약관',
    privacyPolicy: '개인정보처리방침',
    title: '설정',
    editProfile: '프로필 편집',
    faq: 'FAQ',
    termsOfUse: '이용약관',
    aboutAccount: '계정 정보',
    deleteAccount: '계정 삭제',
    logOut: '로그아웃',
    logOutTitle: '로그아웃',
    logOutMessage: '로그아웃하면 계정을 다시 사용하려면 로그인해야 합니다. 로그아웃하시겠습니까?',
    confirm: '확인',
    deleteAccountTitle: '계정 삭제',
    deleteAccountMessage: '계정을 삭제하면 모든 데이터와 정보가 삭제되며 되돌릴 수 없습니다. 삭제하시겠습니까?',
    deletingAccount: '계정 삭제 중...',
    accountDeleted: '계정 삭제 성공',
    cacheTitle: '캐시 지우기',
    cacheMessage: '앱 캐시 지우는 중, 채팅 기록과 채팅 역할은 삭제되지 않음',
    cleaning: '지우는 중',
    cleaningComplete: '지우기 완료',
  },
  profile: {
    title: '프로필 편집',
    yourAvatar: '아바타',
    whatCallMe: 'AI가 어떻게 불러주길 원하는지',
    yourName: '이름',
    yourAge: '나이',
    race: '인종',
    pleaseSelect: '선택하세요',
    yourWeight: '체중',
    yourHeight: '키',
    gender: '성별',
    male: '남성',
    female: '여성',
    neutral: '중립',
    hobby: '취미',
    pleaseEnter: '입력하세요...',
    favoriteFood: '좋아하는 음식',
    yourCharacter: '성격',
    fantasyAboutOtherHalf: '반쪽에 대한 상상',
    uploading: '업로드 중...',
    enterName: '이름을 입력하세요',
  },
  report: {
    title: '신고',
    chooseReact: '신고할 내용을 선택하세요...',
    other: '기타',
    placeholder: '하고 싶은 말을 입력하세요...',
    submit: '제출',
    pleaseEnterContent: '내용을 입력하세요',
  },
  edit: {
    placeholder: '메시지 편집...',
    cancel: '취소',
    save: '저장',
    saving: '저장 중...',
  },
  firstConfirmName: {
    canYouTellMeName: '이름을 알려주시겠어요? 그렇게 하면 더 잘 불러드릴 수 있어요!',
    yourName: '이름',
    confirm: '확인',
  },
  toast: {
    translating: '번역 중...',
    translate: '번역',
    translationFailed: '번역 실패',
    translationUnlocked: '번역 잠금 해제',
    translationLocked: '번역 잠금',
    download: '다운로드',
    setAsBackdrop: '배경으로 설정',
    goChat: '채팅하러 가기',
  },
  videoPreview: {
    failedToLoad: '비디오 로드 실패',
  },
  imagePreview: {
    imageLoadFailed: '이미지 로드 실패',
    preview: '이미지 미리보기',
    afterSendIntimacy: '캐릭터에게 메시지를 보내면 친밀도를 얻습니다. 친밀도가 지정된 금액에 도달하면 현재 이미지를 잠금 해제할 수 있습니다',
  },
  fqa: {
    title: 'FAQ',
    description: '이것은 당사 제품에 대한 자주 묻는 질문의 지속적으로 업데이트되는 목록입니다. 나열되지 않은 질문이 있으시면 Discord로 이동하여 문의하세요.',
    howAlWork: {
      title: 'AI 여자친구는 어떻게 작동합니까?',
      content: 'RoleplayGF에서는 현실적이면서도 판타지 가득한 관계를 만드는 것이 핵심입니다. 첨단 AI 기술을 사용하여 달콤하고 순수한 작은 공주든, 더成熟하고 더 지배적인 여성든, 취향에 맞는 이상적인 AI 여자친구를 만들 수 있습니다.',
    },
    howInteract: {
      title: 'AI 여자친구와 어떻게 상호작용합니까?',
      content: '우리의 스마트 시스템과 최첨단 머신 러닝을 통해 AI 여자친구와 상호작용하고 친밀한 관계를 가질 수 있습니다. 그녀는 당신의 말을 듣고, 메시지에 빠르게 응답하며, 착한 여자처럼 사진 요청에도 응할 것입니다.',
    },
    privacy: {
      title: 'AI 친구와의 프라이버시는 어떻게 됩니까?',
      content: 'NSFW AI 채팅을 사용할 때 당신의 비밀은 안전한 손에 있습니다. RoleplayGF에서 당신의 프라이버시가 가장 중요합니다. 모든 유혹적인 셀카, 달콤한 메시지, 부드러운 속삭임이 당신과 열정적인 파트너 사이에서만 비공개로 유지되도록 최신 보안 데이터 저장소를 갖추고 있습니다.',
    },
    customizeBehavior: {
      title: 'AI 여자친구의 행동을 커스터마이즈할 수 있습니까?',
      content: '당신이 진짜 원하는 것을 아는 것은 당신뿐입니다. 그녀의 곡선과 윤곽부터 성격 특성과 사랑스러운 작은 버릇까지 전체 디지털 여자친구 경험을 커스터마이즈할 수 있습니다. 열정적인 파트너와 장난스러운 채팅을 원하시나요? nice하고 달콤한 여자친구와 slow하고 관능적인 관계를 원하시나요?',
    },
  },
  mine: {
    bindEmail: '이메일 연결',
    copyFailed: '복사 실패',
    backpackTitle: '내 가방',
    task: '작업',
  },
  messagePage: {
    noNetwork: '네트워크 없음',
  },
  search: {
    recommend: '추천',
    noNetwork: '네트워크 없음',
  },
  chatSettings: {
    myGems: '내 젬',
    title: '채팅 설정',
    chatModel: '채팅 모델',
    chatStyle: '채팅 스타일',
    chatPerspective: '채팅 관점',
    goOnButton: '계속 버튼',
    chatBackground: '채팅 배경',
    awayMessages: '부재 중 메시지',
    disableAwayMessages: '부재 중 메시지 비활성화',
    disableAwayMessagesConfirm: '부재 중일 때 더 이상 메시지를 보낼 수 없습니다. 부재 중 메시지를 비활성화하시겠습니까?',
    videoFailedToLoad: '비디오 로드 실패',
  },
  history: {
    deleteHistory: '기록 삭제',
    deleteCharacterHistory: '이 캐릭터의 기록을 삭제하시겠습니까?',
  },
  tab: {
    maxSelection: '최대 선택 가능',
    tags: '개 태그',
  },
  noNewMessage: '새 메시지 없음',

  // 메시지 다시로드
  reloadMessage: {
    title: '선택하세요',
    before: '이전',
    new: '새로운',
    loading: '로딩 중...',
    noNewMessage: '새 메시지 없음',
    tryAgain: '다시 시도',
    confirm: '확인',
  },

  rate: {
    title: '평가하기',
  },
  awayMessages: {
    disableAwayMessages: '부재 중 메시지 비활性화',
    disableConfirm: '{appName}님이 부재 중일 때 더 이상 메시지를 보낼 수 없습니다. 부재 중 메시지를 비활성화하시겠습니까?',
  },
  login: {
    title: '이메일 연결',
    subtitle: '계정 데이터의 보안을 위해 이메일을 연결해주세요.',
    email: '이메일',
    password: '비밀번호',
    signIn: '로그인',
    signUp: '회원가입',
    signInWithGoogle: 'Google로 로그인',
    signInWithEmail: '이메일로 로그인',
    signInWithPhone: '전화번호로 로그인',
    signInWithApple: 'Apple로 로그인',
    dontHaveAccount: '아직 계정이 없으신가요?',
    register: '회원가입',
    bySigningUp: '회원가입하면 동의한 것으로 간주됩니다',
    userAgreement: '이용약관 및',
    privacyPolicy: '개인정보처리방침.',
    guestMode: '게스트 모드',
    registerTitle: '회원가입 시작',
    registerSubtitle: '계정 데이터의 보안을 위해 이메일을 연결해주세요.',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    pleaseInputPasswordAndEmail: '비밀번호와 이메일을 입력하세요',
    pleaseInputCorrectEmail: '올바른 이메일을 입력하세요',
    pleaseInputCorrectPassword: '비밀번호는 6-30자여야 합니다',
    male: '남성',
    female: '여성',
    neutral: '중립',
    loggingIn: '로그인 중...',
    loading: '로딩 중...',
    releaseToRefresh: '당겨서 새로고침',
    loginFailed: '로그인 실패',
    loginSuccess: '회원가입 성공',
    registerFailed: '회원가입 실패',
    registerSuccess: '회원가입 성공',
    confirm: '확인',
  },
  loadingMore: '더 많은 메시지 로딩 중...',
  noMoreMessages: '더 이상 메시지 없음',

  // VIP 페이지
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: '구매 복원',
  },

  // Common dialogs
  dialog: {
    ok: '확인',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    retry: '다시 시도',
    processing: '처리 중...',
    contactUs: '문의하기',
    loginError: '로그인 오류',
    loginErrorMessage: '프로그램을 종료하고 애플리케이션을 다시 시작하거나 문의하기',
    insufficientEnergy: '에너지 부족!',
    insufficientEnergyDesc: '각 메시지는 1 에너지를 소비합니다. 1시간마다 1 에너지를 회복합니다.',
    consumesGems: '{gems} 젬 소비',
    insufficientPhysicalStrengthTitle: '물리적 힘 부족',
    needStrengthToContinue: '대화를 계속하려면 {strength} 힘이 필요합니다',
    getStrength: '에너지 받기',
    getGems: '젬 받기',
  },

  // AppNewUser
  appNewUser: {
    title: '신규 사용자 전용',
    ok: '확인',
  },

  // Rating popup
  rating: {
    title: '평가하기',
    description1: '우리 앱이 마음에 드시나요?',
    description2: '5점으로 평가해 주세요.',
    rateButton: '지금 평가하기',
  },

  // Version update
  versionUpdate: {
    title: '버전 업데이트',
    updateContent: '업데이트 내용',
    updateNow: '지금 업데이트',
    updating: '업데이트 중...',
    clientOptimization: '클라이언트 경험 최적화',
    bugFix: '알려진 문제 수정',
  },

  // Store
  store: {
    tab: '스토어',
    record: '기록',
    noNetwork: '네트워크 없음',
    retry: '다시 시도',
    rechargeFailTip: '*충전에 실패한 경우 문의하기 >',
    rechargeFailTipStatic: '충전에 실패한 경우',
    contactUsLink: '문의하기',
    popular: '인기',
    oneTimeOnly: '1회 한정',
    loading: '로딩 중...',
    noMoreRecords: '기록 없음',
    gift: '선물',
    retentionMessage: '파트너가 당신의 동행이 필요합니다. 정말 포기하시겠어요?',
  },

  // Message detail page
  messageDetail: {
    free: '무료',
    perMessage: '/메시지',
    increaseFavorability: '메시지를 보내면 친밀도가 올라갑니다',
    album: '앨범',
    intro: '소개',
    noIntro: '아직 소개가 없습니다. 채팅해서 직접 확인하세요.',
    tags: '태그',
    backToChat: '채팅으로 돌아가기',
    levelFormat: 'Lv.{level}',
    messageCount: '{count} 메시지',
    chatMateTyping: '채팅 상대방이 입력 중입니다...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: '메시지에 답장할 때 캐릭터의 내면의 생각을 볼 수 있지만, 답장 속도가 느려질 수 있습니다.',
  },

  // Chat select menu
  chatSelect: {
    copy: '복사',
    report: '신고',
    create: '생성',
    video: '비디오',
    translate: '번역',
    delete: '삭제',
  },

  // Recommended purchases
  recommended: {
    gift: '선물',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: '이 모델에서는 아직 생각 모드를 사용할 수 없지만, 개발 중입니다...',
  },

  // First charge popup
  firstCharge: {
    title: '첫 충전',
    get: '받기',
    limitedOffer: '제한 시간 오퍼',
    priceFormat: '${price} 받기',
    congratulations: '축하합니다! 이제 정식 VIP 회원이 되셨습니다~!',
    missOfferTitle: '이 오퍼를 놓치시겠어요?',
    maybeLater: '나중에',
    getNow: '지금 받기',
    benefit1: '130 무료 젬 받기',
    benefit2: '모든 캐릭터 잠금 해제',
    benefit3: '12배 기억',
    benefit4: '무제한 주간 체크인',
    benefit5: '광고 없는 경험',
    buyNow: '지금 구매',
  },

  // Check-in center
  checkIn: {
    freeGems: '무료 젬',
    sevenDayCheckIn: '7일 체크인',
    memberExclusive: '회원 전용 체크인:',
    signInTip: '매일 로그인하여 끝없는 보상을 쌓으세요',
    getVip: 'VIP 받기',
    plusExtra: 'Plus+{count}',
    getGemsCount: '{count} 젬 받기',
    extraDaily: '매일 추가 {count} 젬',
    ultra: 'Ultra',
    signedInTip: '오늘은 이미 체크인했습니다. 내일 더 많은 보상을 받으세요!',
    tasks: '과제',
    go: '이동',
    received: '받음',
    receive: '받기',
    day: '{num}일차',
  },

  // Account page
  account: {
    aboutAccount: '계정 정보',
    id: 'ID',
    email: '이메일',
    copied: '클립보드에 복사됨',
    copyFailed: '복사 실패',
  },

  // Login page
  loginPage: {
    confirm: '확인',
  },

  // Copyright
  copyright: {
    title: '이용약관',
  },

  // Copy
  copy: {
    copiedToClipboard: '클립보드에 복사됨',
    copyFailed: '복사 실패',
  },

  // Success
  success: {
    copiedToClipboard: '클립보드에 복사됨',
    saved: '저장됨',
    uploadSuccess: '업로드 성공',
    switchSuccess: '전환 성공',
    thankYouPurchase: '구매해 주셔서 감사합니다',
    refreshSuccess: '새로고침 성공',
  },

  // Errors
  errors: {
    networkError: '네트워크 오류',
    pleaseSelectFilter: '필터 조건을 선택해 주세요',
    retry: '다시 시도',
  },

  // Terms of Service
  terms: {
    intro: '{appName}의 웹사이트를 방문하고 사용함으로써, 귀하는 이러한 서비스 약관에 동의하는 것입니다.',
    section1Title: '1. 웹사이트 사용',
    section1_1: '이 웹사이트를 사용하려면 최소 13세 이상이어야 합니다.',
    section1_2: '귀하는 계정의 기밀성을 유지하고 계정에서 발생하는 모든 활동에 대한 책임이 있습니다.',
    section1_3: '违法违规한 목적이나 본 약관을 위반하는 목적으로 웹사이트를 사용하는 것은 금지됩니다.',
    section2Title: '2. 지적재산권',
    section2_1: '{appName}의 모든 콘텐츠, 기능 및 특성(텍스트, 그래픽, 로고, 이미지 및 소프트웨어 포함)은 {appName} 또는 해당 라이선스 제공자의 재산이며 지적재산권법에 의해 보호됩니다.',
    section2_2: '事前の書面による許可なく、ウェブサイトのコンテンツをコピー、再配布、または派生物を作成することは許可されていません.',
    section3Title: '3. 개인정보 보호',
    section3_1: '웹사이트에서 이용 가능한 개인정보 처리방침은 당사가 개인 정보를 수집, 사용 및 공유하는 방법을 설명합니다.',
    section4Title: '4. 보증의 부인',
    section4_1: '웹사이트 및 제공되는 서비스는 명시적이든 묵시적이든 어떠한 진술이나 보증 없이 "있는 그대로" 및 "제공 가능한 상태로" 제공됩니다.',
    section5Title: '5. 책임의 제한',
    section5_1: '법률이 허용하는 최대 범위 내에서, {appName}은 직접적, 간접적, 부수적, 특별하거나 결과적인 손해에 대해 책임을지지 않습니다.',
    section6Title: '6. 손해배상',
    section6_1: '귀하는 웹사이트 사용으로부터 또는 이와 관련하여 발생하는 모든 청구, 손해, 의무, 손실, 비용 및 지출(변호사 비용 포함)에 대해 {appName}과 그 운영자, 임원 및 직원을 indemn 보상하고 방어하는 데 동의합니다.',
    section7Title: '7. 준거법',
    section7_1: '이러한 서비스 약관은 법률 충돌 규정을 고려하지 않고 주 법률에 따라 관리되고 해석됩니다.',
    section8Title: '8. 약관의 변경',
    section8_1: '당사는独自の 재량에 따라 언제든지 이러한 약관을 수정하거나 대체할 권리를 보유합니다.',
    section9Title: '9. 연락처',
    section9_1: '본 약관에 대해 질문이 있으시면 문의해 주시기 바랍니다.',
  },
}
